import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { Text } from "@fragments";

import { getNotifyOptions } from "../../../enums/notifyOptions";
import OptionPopper from "../OptionPopper";
import { OptionRow } from "../Visibility";

/**
 * "Notify the members" panel: e-mail them at the publish moment, or keep the
 * post in the feed only. Same row recipe as the visibility panel; picking a
 * row applies it and closes the panel.
 */
export default function NotifyPopper({ open, anchorEl, value, onChange, onClose }) {
    const { t } = useTranslation("groupModals");

    const options = useMemo(() => getNotifyOptions(t), [t]);

    function select(optionValue) {
        onChange(optionValue);
        onClose();
    }

    return (
        <OptionPopper
            open={open}
            anchorEl={anchorEl}
            onClose={onClose}
            width={320}
            label={t("publishPost.notify.title")}
        >
            <div className="pp-popper__header">
                <Text.subheading contrast={6}>{t("publishPost.notify.title")}</Text.subheading>
            </div>

            <div className="pp-popper__list" role="radiogroup" aria-label={t("publishPost.notify.title")}>
                {options.map(({ value: optionValue, Icon, label, description }) => (
                    <OptionRow
                        key={String(optionValue)}
                        Icon={Icon}
                        label={label}
                        description={description}
                        selected={optionValue === value}
                        onSelect={() => select(optionValue)}
                    />
                ))}
            </div>

            <div className="pp-popper__note">
                <Text.caption contrast={6}>{t("publishPost.notify.restrictedNote")}</Text.caption>
            </div>
        </OptionPopper>
    );
}
